var map = {
	"./ToggleTwoFactorAuthenticationIcon.svg": 8442,
	"./brand.svg": 7099,
	"./brandDark.svg": 5146,
	"./download-apple.svg": 2591,
	"./download-google.svg": 6612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;